"use strict";

import React, { Component } from "react";
import PropTypes from "prop-types";
import { BrowserRouter, Navigate } from "react-router-dom";

import { Provider } from "react-redux";
// import { ConnectedRouter } from "connected-react-router";

import Routes from "./routes/Routes";
// import RouteLink from "./routes/RoutesLink";
import { PersistGate } from "redux-persist/integration/react";
// import { hot } from "react-hot-loader/root";
// import UiAlert, {
//     UiAlertWarning,
// } from "./components/_uiComponents/common/UiAlert";
// import UIPageLoader from "./components/_uiComponents/common/ContentLoaders/UIPageLoader";
// import UiConfirmation from "./components/_uiComponents/common/UiConfirmation";
// import UiConfirmServerAlert from "./components/_uiComponents/common/UiConfirmServerAlert";
// import UiAlertSuccess from "./components/_uiComponents/common/UiAlertSuccess";
import { UiFullLoadingSpinner } from "./components/_uiComponents/common/UiLoadingSpinner";
import UiErrorAlertBox from "./components/_uiComponents/common/UiErrorAlertBox";
import UiSuccessAlertBox from "./components/_uiComponents/common/UiSuccessAlertBox";

import UiSidePanel from "./components/_uiComponents/side-panel/UISidePanel";

import {
    UiLargeModal,
    UiChatBotModal,
    UiFooterContentModal,
    UiHomePerformanceModal,
    UiProfileImgModal,
    UiSurveyModal,
    UiRedirectModal,
    UiMessageModal,
    UiMultiPdfViewerModal,
    UiInfoModal,
    UiDataInfoModal,
    UiConfirmationModal,
} from "./components/_uiComponents/common/UiModal";

//ui states
import ContextStore from "./_context/Store";

class App extends Component {
    constructor(props) {
        super(props);
    }

    static get propTypes() {
        return {
            history: PropTypes.object.isRequired,
            store: PropTypes.object.isRequired,
        };
    }

    render() {
        return (
            <>
                <Provider store={this.props.store}>
                    <PersistGate
                        loading={null}
                        persistor={this.props.persistor}
                    >
                        {/* <ConnectedRouter history={this.props.history}> */}
                        <ContextStore>
                            <BrowserRouter>
                                <UiConfirmationModal />
                                <UiDataInfoModal />
                                <UiSidePanel />
                                <UiLargeModal />
                                <UiMessageModal />
                                <UiChatBotModal />
                                <UiFooterContentModal />
                                <UiProfileImgModal />
                                <UiSurveyModal />
                                <UiRedirectModal />
                                <UiErrorAlertBox />
                                <UiSuccessAlertBox />
                                <UiMultiPdfViewerModal />
                                <UiInfoModal />
                                <UiFullLoadingSpinner fullLoading={true} />
                                {/* 
                            <UiAlert {...this.props} /> <UiAlertWarning {...this.props} />
                            <UiAlertSuccess />
                            <UiConfirmation />
                            <UiConfirmServerAlert {...this.props} /> */}
                                <Routes />
                            </BrowserRouter>
                        </ContextStore>
                        {/* </ConnectedRouter> */}
                    </PersistGate>
                </Provider>
            </>
        );
    }
}

export default App;
